import getColor from "@insite/mobius/utilities/getColor";
import { slideshowStyles } from "@waytek/Overrides/Widgets/Basic/Slideshow";
import { colorPalette, getScrollbarWidth, mediaQueriesBP } from "@waytek/Utilities/variables";
import { css } from "styled-components";

const localColors = {
    globalIndustrialTaupe: getColor("common.global.industrialTaupe"),
    globalWhite: getColor("common.global.white"),
    globalGuardianBlue: getColor("common.global.guardianBlue"),
};

slideshowStyles.slideshowWrapper = {
    ...slideshowStyles.slideshowWrapper,

    css: css`
        ${slideshowStyles.slideshowWrapper?.css}
        padding-block: 40px 60px;
        background-color: ${colorPalette.common.global.fadedTaupe};

        ${mediaQueriesBP.minMD} {
            width: calc(100% + 20px);
            margin-left: -10px;
        }

        ${mediaQueriesBP.maxMD} {
            width: 100vw;
            margin-left: calc(50% - 50vw);
            padding-block: 40px;
        }

        &::before {
            top: 0;
            content: "";
            display: block;
            height: 100%;
            background-color: ${colorPalette.common.global.fadedTaupe};
            position: absolute;
            inset-inline: 50%;
            width: calc(100vw - ${getScrollbarWidth()});
            margin-inline: -50vw;
            box-sizing: border-box;
        }
    `,
};

slideshowStyles.slideContentWrapper = {
    ...slideshowStyles.slideContentWrapper,

    css: css`
        ${slideshowStyles.slideContentWrapper?.css}

        height: 0;

        &.is-selected {
            height: auto;
        }
    `,
};

slideshowStyles.slideshowWrapperContainer = {
    ...slideshowStyles.slideshowWrapperContainer,

    css: css`
        display: flex;
        flex-direction: column;
        width: 100%;
        border: 1px solid ${localColors.globalIndustrialTaupe};

        ${mediaQueriesBP.minMD} {
            flex-direction: row;
        }
    `,
};

slideshowStyles.slideshowWrapperImg = {
    ...slideshowStyles.slideshowWrapperImg,

    css: css`
        position: relative;
        font-size: 0;
        width: 60%;

        ${mediaQueriesBP.maxMD} {
            width: 100%;
            &::after {
                display: block;
                content: "";
                position: absolute;
                width: 100%;
                height: 100%;
                top: 0;
                left: 0;
                background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0) 53%, rgba(0, 0, 0, 0.6));
            }
        }
    `,
};

slideshowStyles.img = {
    ...slideshowStyles.img,

    css: css`
        width: 100%;
        height: 100%;
        object-fit: cover;
        aspect-ratio: 16 / 9;
    `,
};

slideshowStyles.slideshowWrapperContent = {
    ...slideshowStyles.slideshowWrapperContent,

    css: css`
        padding: 20px 30px 50px;
        background-color: ${localColors.globalWhite};
        width: 100%;

        ol,
        ul {
            padding-left: 16px;
        }

        &.hasDivider {
            border-top: 1px solid ${localColors.globalIndustrialTaupe};
            border-left: 0;
        }

        ${mediaQueriesBP.minMD} {
            display: flex;
            width: 40%;
            padding: 40px;
            flex-direction: column;

            &.hasDivider {
                border-left: 1px solid ${localColors.globalIndustrialTaupe};
                border-top: 0;
            }
        }
    `,
};

slideshowStyles.headingText = {
    ...slideshowStyles.headingText,

    css: css`
        margin-bottom: 10px;

        ${mediaQueriesBP.minLG} {
            margin-bottom: 5px;
        }
    `,
};

slideshowStyles.subheadingText = {
    ...slideshowStyles.subheadingText,

    css: css`
        margin-bottom: 20px;
    `,
};

slideshowStyles.dotsContainerWrapper = {
    ...slideshowStyles.dotsContainerWrapper,

    css: css`
        ${slideshowStyles.dotsContainerWrapper?.css}
        pointer-events: none;
        margin-top: 0;
        top: 0;
        padding-top: 58%;

        ${mediaQueriesBP.minMD} {
            margin-top: 24px;
            top: auto;
            justify-content: flex-end;
            padding-top: 0;
        }
    `,
};

slideshowStyles.dotButton = {
    ...slideshowStyles.dotButton,

    css: css`
        pointer-events: all;
        width: 10px;
        padding: 0;
        height: 10px;
        min-height: auto;
        border-radius: 50%;
        margin: 0 5px;
        border: solid 1px ${localColors.globalWhite};
        background-color: ${localColors.globalWhite};

        &:hover,
        &:not(:disabled):hover {
            border: solid 1px ${localColors.globalWhite};
            background-color: ${localColors.globalGuardianBlue};
        }

        &::after {
            display: none;
            content: none;
        }

        &:focus {
            outline: none;
        }

        &.is-selected {
            border: solid 1px ${localColors.globalWhite};
            background-color: ${localColors.globalGuardianBlue};
        }

        @media (hover: none) {
            &:hover,
            &:not(:disabled):hover {
                border: solid 1px ${localColors.globalWhite};
                background-color: ${localColors.globalWhite};
            }

            &.is-selected,
            &.is-selected:hover {
                border: solid 1px ${localColors.globalWhite};
                background-color: ${localColors.globalGuardianBlue};
            }
        }

        ${mediaQueriesBP.minMD} {
            margin-top: auto;
            border: solid 1px ${localColors.globalGuardianBlue};
            background-color: ${localColors.globalWhite};

            &:hover,
            &:not(:disabled):hover {
                border: solid 1px ${localColors.globalGuardianBlue};
                background-color: ${localColors.globalGuardianBlue};
            }

            &.is-selected {
                border: solid 1px ${localColors.globalGuardianBlue};
                background-color: ${localColors.globalGuardianBlue};
            }

            @media (hover: none) {
                &:hover,
                &:not(:disabled):hover {
                    border: solid 1px ${localColors.globalGuardianBlue};
                    background-color: ${localColors.globalWhite};
                }

                &.is-selected,
                &.is-selected:hover {
                    border: solid 1px ${localColors.globalGuardianBlue};
                    background-color: ${localColors.globalGuardianBlue};
                }
            }
        }
    `,
};
